import { render, staticRenderFns } from "./MenuSA31.vue?vue&type=template&id=04bbddfe&scoped=true&"
import script from "./MenuSA31.vue?vue&type=script&lang=js&"
export * from "./MenuSA31.vue?vue&type=script&lang=js&"
import style0 from "./MenuSA31.vue?vue&type=style&index=0&id=04bbddfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bbddfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VIcon,VList,VMenu})
